import React from "react"

// components
import Banner from "../components/banner"
import Footer from "../components/footer"

const SingThursday = () => {
  return (
    <div className="media-page error">
      <Banner bannerClass="error-banner"></Banner>

      <Footer />
    </div>
  )
}

export default SingThursday
